<template>
  <div v-if="editors.length > 0" class="tw-flex items-center gap-2">
    <!-- Avatar stack -->
    <div class="tw-flex -space-x-2">
      <div
        v-for="editor in visibleEditors"
        :key="editor.id"
        class="w-7 h-7 rounded-full border-2 border-white bg-primary-100 tw-flex items-center justify-center overflow-hidden relative"
        :title="editorLabel(editor)"
      >
        <img v-if="editor.photo_url" :src="editor.photo_url" :alt="editor.name" class="w-full h-full object-cover"/>
        <span v-else class="text-xs font-semibold text-primary-700">{{ initials(editor.name) }}</span>
        <!-- Green dot for active -->
        <span class="absolute bottom-0 right-0 w-2 h-2 bg-green-400 rounded-full border border-white"></span>
      </div>
      <div
        v-if="overflowCount > 0"
        class="w-7 h-7 rounded-full border-2 border-white bg-gray-200 tw-flex items-center justify-center"
        :title="`${overflowCount} more`"
      >
        <span class="text-xs font-semibold text-gray-600">+{{ overflowCount }}</span>
      </div>
    </div>

    <!-- Label -->
    <span class="text-xs text-gray-500">
      <span v-if="otherEditors.length === 1">
        <strong class="text-gray-700">{{ otherEditors[0].name }}</strong> {{ $t('knowledge_base_is_editing') }}
      </span>
      <span v-else-if="otherEditors.length > 1">
        {{ otherEditors.length }} {{ $t('knowledge_base_others_editing') }}
      </span>
      <span v-else class="text-green-600">{{ $t('knowledge_base_only_you_editing') }}</span>
    </span>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'KnowledgeBaseEditorPresence',
    props: {
      editors: {
        type: Array,
        default: () => [],
      },
      currentUserId: {
        type: Number,
        required: true,
      },
    },
    computed: {
      otherEditors(): any[] {
        return (this.editors as any[]).filter(e => e.id !== this.currentUserId)
      },
      visibleEditors(): any[] {
        return (this.editors as any[]).slice(0, 4)
      },
      overflowCount(): number {
        return Math.max(0, (this.editors as any[]).length - 4)
      },
    },
    methods: {
      initials(name: string): string {
        return name
          ?.split(' ')
          .map((n: string) => n[0])
          .join('')
          .toUpperCase()
          .slice(0, 2) || '?'
      },
      editorLabel(editor: any): string {
        return editor.id === this.currentUserId
          ? `${editor.name} (${this.$t('knowledge_base_you')})`
          : editor.name
      },
    },
  })
</script>
